import React from 'react';
import { Control } from 'react-hook-form';
import { UpsertEmailTemplateDto } from '../../../containers/EmailTemplates/SetupEmailTemplatePage/UpsertEmailTemplateDto';
import { Col } from 'reactstrap';
import { FormFieldHeader } from '../../FormFieldHeader';
import { EMAIL_TEMPLATE_VARIABLES } from '../../../containers/EmailTemplates/SetupEmailTemplatePage/Body/CopyVariables';
import { InputRichTextComposer } from '../../RichTextEditor/composers/InputRichTextComposer';
import { RichTextEditor } from '../../RichTextEditor';
import { PasteVariablePlugin } from '../../RichTextEditor/plugins/PasteVariablePlugin';
import { UpdateStatePlugin } from '../../RichTextEditor/plugins/UpdateStatePlugin';

const FIELD_NAME = 'subject';
interface PropTypes {
  control: Control<UpsertEmailTemplateDto, any>;
  subject?: string;
  title?: string;
  colSize?: number;
  setSubjectText: (text: string) => void;
}

export function SubjectInput(props: PropTypes) {
  return (
    <Col xs={props.colSize || 6}>
      <FormFieldHeader fieldName={props.title || 'Subject'} isRequired={true} />
      <RichTextEditor<UpsertEmailTemplateDto>
        formHookContext={{
          controllerName: FIELD_NAME,
          formControl: props.control,
          required: true,
        }}
        render={(field) => (
          <InputRichTextComposer
            defaultEditorState={field.value as string}
            onChangeText={props.setSubjectText}
            onChangeJson={(value: string) => field.onChange(value)}
            externalPlugins={[
              <UpdateStatePlugin key={1} editorState={props.subject} />,
              <PasteVariablePlugin
                key={2}
                variables={Object.values(EMAIL_TEMPLATE_VARIABLES)}
              />,
            ]}
            placeholder='Insert Subject'
          />
        )}
      />
    </Col>
  );
}
